module.exports = __webpack_public_path__ + "static/media/logo.6e871a5e.svg";